import { render } from "./SaveOrgUnit.vue?vue&type=template&id=391369a4&scoped=true"
import script from "./SaveOrgUnit.vue?vue&type=script&lang=js"
export * from "./SaveOrgUnit.vue?vue&type=script&lang=js"

import "./SaveOrgUnit.vue?vue&type=style&index=0&id=391369a4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391369a4"]])

export default __exports__